/**
 * @fileoverview GET handler for the "/generative_ai/brand_guideline" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiBrandGuideline } from "./constants";
import type { GenerativeAiBrandGuidelineResult } from "./types";
import { isGenerativeAiBrandGuidelineResult } from "./validators";

export const getGenerativeAiBrandGuideline = reactQueryFetcherAdapter(
  generativeAiBrandGuideline,
  (signal: AbortSignal, guidelineId: string): Promise<GenerativeAiBrandGuidelineResult> => {
    return fetch("/generative_ai/brand_guideline", "GET", { guideline_id: guidelineId }, { signal });
  },
  isGenerativeAiBrandGuidelineResult
);
